module.exports = __webpack_public_path__ + "static/media/welcome-background2.e26c9d55.jpg";